import Vue from 'vue'
import { Message } from 'iview'

// 为空校验
Vue.prototype.$validateEmpty=function(name,message){
    if(!name){
        Message.error(message)
        return false
    }

    return true
}


// WEBPACK FOOTER //
// ./src/utils/validate.js